import { UnavailabilityReason, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    unavailabilityReasons: Identifiable<UnavailabilityReason>[];
  };
};
function getUnavailabilityReasons(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: "/unavailabilityReasons",
        method: HttpMethods.GET,
      })
      .then((response) => response._embedded.unavailabilityReasons);
}

export { getUnavailabilityReasons };
